import './App.css';
import { Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import Lenis from 'lenis';
import Footer from './components/Footer/Footer';
import NavBar from './components/NavBar/NavBar';
import Home from './pages/Home/Home';
import ContactUs from './pages/ContactUs/page';

import Events from './pages/Events/events';
import SilverMembers from './pages/SilverMembers/SilverMembers';
import UploadImages from './pages/UploadImages/UploadImages';
import ScrollToTop from './utils/ScrollToTop/ScrollToTop';
import PopupBanner from './components/ui/PopupBanner';


function App() {
  useEffect(() => {
    // Initialize Lenis smooth scrolling
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // Custom easing function
      direction: 'vertical', // 'vertical' or 'horizontal'
      gestureDirection: 'vertical', // 'vertical', 'horizontal', or 'both'
      smooth: true,
      mouseMultiplier: 1,
      smoothTouch: false,
      touchMultiplier: 2,
      infinite: false,
    });

    // Animation frame function for Lenis
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    // Cleanup function
    return () => {
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <PopupBanner imageUrl="/Postponed Flyer 2.jpg" />
      <NavBar />
            <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/events" element={<Events />} />
        <Route path="/silver-members" element={<SilverMembers />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/events" element={<Events />} />
        {/* <Route path="/upload-images" element={<UploadImages />} /> */}
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
